import http from "./base";

class OrderService{
    constructor(){}


    async saveNewOrder(body) {
        const url = `orders`;
        var response = "";
        await http
            .post(url, body,{
                headers: {
                    authorization: 'Bearer ' + sessionStorage.getItem('token')
                  },
            })
            .then(responseData => {
                response = responseData.data.data;
            })
            .catch(error => {
                response = error.response;
                throw new Error(`HTTP error! status: ${response.status}`);
            });

        return response;
    }

    async updateOrderByID(id,body) {
        const url = `orders/`+id;
        var response = "";
        await http
            .patch(url,body,{
                headers: {
                    authorization: 'Bearer ' + sessionStorage.getItem('token')
                  },
            })
            .then(responseData => {
                response = responseData.data.data;
            })
            .catch(error => {
                response = error.response;
                throw new Error(`HTTP error! status: ${response.status}`);
            });

        return response;
    }

    async cancelOrder(id,body){
        const url = `orders/cancel/`;
        var response = "";
        await http
            .post(url,body,{
            })
            .then(responseData => {
                response = responseData.data.data;
            })
            .catch(error => {
                response = error.response;
                throw new Error(`HTTP error! status: ${response.status}`);
            });

        return response;
    }

    async cancelAllRemainingOrders(venueID,barID){
        const url = `orders/cancelAll/`;
        var response = "";
        await http
            .post(url,{venueID,barID},{
            })
            .then(responseData => {
                response = responseData.data;
            })
            .catch(error => {
                response = error.response;
                throw new Error(`HTTP error! status: ${response.status}`);
            });

        return response;
    }


    async declineOrder(_id,bar_id){
        const url = `orders/decline/`;
        var response = "";
        await http
            .post(url,{_id,bar_id},{
            })
            .then(responseData => {
                response = responseData.data.data;
            })
            .catch(error => {
                response = error.response;
                throw new Error(`HTTP error! status: ${response.status}`);
            });

        return response;
    }

    async refundOrder(id,body){
        const url = `orders/refund/`;
        var response = "";
        await http
            .post(url,body,{
            })
            .then(responseData => {
                response = responseData.data.data;
            })
            .catch(error => {
                response = error.response;
                throw new Error(`HTTP error! status: ${response.status}`);
            });

        return response;
    }


    async pingOrder(id,body){
        const url = `orders/ping/`+id;
        var response = "";
        await http
            .post(url,body,{
                headers: {
                    authorization: 'Bearer ' + sessionStorage.getItem('token')
                },
            })
            .then(responseData => {
                response = responseData.data.data;
            })
            .catch(error => {
                response = error.response;
                throw new Error(`HTTP error! status: ${response.status}`);
            });

        return response;
    }

    async acceptOrder(id,body){
        const url = `orders/accept/`+id;
        var response = "";
        await http
            .post(url,body,{
                headers: {
                    authorization: 'Bearer ' + sessionStorage.getItem('token')
                  },
            })
            .then(responseData => {
                response = responseData.data;
            })
            .catch(error => {
                console.log(error)
                response = error.response;
                throw new Error(`HTTP error! status: ${response.status}`);
            });

        return response;
    }

    async acceptModifiedOrder(id,body){
        const url = `orders/acceptModifiedOrder/`+id;
        var response = "";
        await http
            .post(url,body,{
                headers: {
                    authorization: 'Bearer ' + sessionStorage.getItem('token')
                  },
            })
            .then(responseData => {
                response = responseData.data;
            })
            .catch(error => {
                response = error.response;
                throw new Error(`HTTP error! status: ${response.status}`);
            });

        return response;
    }

    async completeOrder(id,body){
        const url = `orders/complete/`+id;
        var response = "";
        await http
            .post(url,body,{
                headers: {
                    authorization: 'Bearer ' + sessionStorage.getItem('token')
                  },
            })
            .then(responseData => {
                response = responseData.data.data;
            })
            .catch(error => {
                response = error.response;
                throw new Error(`HTTP error! status: ${response.status}`);
            });

        return response;
    }

    async deleteOrderByID(id) {
        const url = `orders/`+id;
        var response = "";
        await http
            .delete(url,{
                headers: {
                    authorization: 'Bearer ' + sessionStorage.getItem('token')
                  },
            })
            .then(responseData => {
                response = responseData.data.data;
            })
            .catch(error => {
                response = error.response;
                throw new Error(`HTTP error! status: ${response.status}`);
            });

        return response;
    }


    async getAllPendingOrders(venueID,barID)  {
        const url = `orders/`;

        var response = "";
        await http
            .get(url, {
                cache: false,
                params:{
                    venueID,
                    barID

                }
            })
            .then(responseData => {
                response = responseData.data.data;
            })
            .catch(error => {
                response = error.response;
                throw new Error(`HTTP error! status: ${response.status}`);
            });

        return response;
    }


    async getHistoricOrders(data) {
  const url = `orderHistory`;

  let response = "";
  const { venueId, barID, startDate,endDate } = data

  await http
    .get(url, {
      cache: false,
      params: {
        venueId,
        barID,
        startDate,
        endDate,
      }
    })
    .then(responseData => {
      response = responseData.data.data;
    })
    .catch(error => {
      response = error.response;
      throw new Error(`HTTP error! status: ${response?.status}`);
    });

  return response;
}

    async getHomePageMetrics() {
  const url = `orderHistory/getHomePageMetrics`;
 

  let response = "";

  await http
    .get(url, {
      cache: false,
      params: {
        userID: sessionStorage.getItem('user'),
        businessID: sessionStorage.getItem('businessID'),
        isBusiness: sessionStorage.getItem('isBusiness'),
      }
    })
    .then(responseData => {
      response = responseData.data.data;
    })
    .catch(error => {
      response = error.response;
      throw new Error(`HTTP error! status: ${response?.status}`);
    });

  return response;
}


}

let service = new OrderService();
export default service;



